import { render, staticRenderFns } from "./favorite-groups-model.vue?vue&type=template&id=76b55fe8&scoped=true&slot=footer"
import script from "./favorite-groups-model.vue?vue&type=script&lang=js"
export * from "./favorite-groups-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b55fe8",
  null
  
)

export default component.exports